import { useCallback } from 'react'
import { routes } from '@shared/constants/routes'
import { useRouteToSearch } from '@/features/shared/hooks/useRouteToSearch'
import { type OnComboboxItemArgs } from '@/features/shared/hooks/a11y/useCombobox'
import { datadogRum } from '@datadog/browser-rum'
import {
  SEARCH_CORE_RESULTS_DURATION,
  SEARCH_PAGE_RESULTS_DURATION,
  MULTI_STORE_SEARCH_PAGE_RESULTS_DURATION,
} from '@/lib/datadog/vitals'

export const useRouteToSearchFromAutocomplete = ({ isMultiStoreSearch = false }) => {
  const { routeToSearch } = useRouteToSearch()

  return useCallback(
    (query: string, { suggestion }: OnComboboxItemArgs) => {
      const context = {
        searchType: suggestion ? 'autocomplete' : 'typed',
        query,
      }
      if (!isMultiStoreSearch) {
        datadogRum.startDurationVital(SEARCH_CORE_RESULTS_DURATION, {
          description:
            'Time from user submitting a search query to core search results being returned',
          context,
        })
        datadogRum.startDurationVital(SEARCH_PAGE_RESULTS_DURATION, {
          description:
            'Time from user submitting a search query to all search page content settling (results, ads, shelves)',
          context,
        })
      } else {
        datadogRum.startDurationVital(MULTI_STORE_SEARCH_PAGE_RESULTS_DURATION, {
          description:
            'Time from user submitting a multi-store search to both stores and search results being returned and the page rendering',
          context,
        })
      }
      return routeToSearch({
        params: {
          query,
          searchType: suggestion ? 'autocomplete' : 'typed',
        },
        ...(isMultiStoreSearch && { pathname: routes.GLOBAL_SEARCH.url }),
      })
    },
    [routeToSearch, isMultiStoreSearch],
  )
}
